import * as React from 'react'
import Form from '../Form'
import {
  ReservationStepHeader,
  ReservationStepBody,
} from '../ReservationStepHeader'
import { ReservationNote } from '../ReservationNote'

import { ContentType, TrialLessonIndexView } from '../../types/trialLessons'
import { CurrentUser } from '../../types/currentUser'

type Props = {
  stepText?: string
  id?: string
  jwtToken?: string
  selectedLesson: TrialLessonIndexView
  currentUser?: CurrentUser
  isRescheduled?: boolean
  reservationId?: string
  isMulticreator?: boolean
  location?: string
  isShares?: boolean
  contentType?: ContentType
}

export const UserFormPane = ({
  stepText = 'STEP2',
  id = 'step2',
  jwtToken = '',
  selectedLesson,
  currentUser,
  isRescheduled,
  reservationId,
  isMulticreator,
  location,
  isShares,
  contentType,
}: Props) => (
  <div id="user-form-pane">
    {!isShares && (
      <ReservationStepHeader id={id} stepText={stepText}>
        お客様の情報をご入力ください
      </ReservationStepHeader>
    )}
    <ReservationStepBody>
      <div className="desktop:max-w-[600px] desktop:my-10 desktop:mx-auto desktop:mb-20 tablet:my-10 tablet:mx-10 tablet:mb-20 sp:my-[8.53vw] sp:mx-4 sp:mb-[21.33vw]">
        <Form
          jwtToken={jwtToken}
          selectedLesson={selectedLesson}
          currentUser={currentUser}
          isRescheduled={isRescheduled}
          reservationId={reservationId}
          isMulticreator={isMulticreator}
          location={location}
          contentType={contentType}
        />
        <ReservationNote isMulticreator={isMulticreator} />
      </div>
    </ReservationStepBody>
  </div>
)
